import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculators-student-loans.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import * as $ from 'jquery';
var CalculatorsStudentLoans = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorsStudentLoans, _super);
    function CalculatorsStudentLoans(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.timeout = null;
        _this.formValid = true;
        return _this;
    }
    CalculatorsStudentLoans.prototype.init = function () {
        this.inputs = Array.from(this.element.querySelectorAll('input'));
        this.modifiers = Array.from(this.element.querySelectorAll('.js-calculator-modifier'));
        this.modifierToggles = Array.from(this.element.querySelectorAll('.js-calculator-modifier-toggle'));
        this.modifiersRadiosToggle = Array.from(this.element.querySelectorAll('.js-calculator-radio-group'));
        this.addonToggles = Array.from(this.element.querySelectorAll('.js-calculator-addon-toggle'));
        this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-calculator-student-loans-calculate'));
        this.calculatorReset = Array.from(this.element.querySelectorAll('.js-calculators-student-loans-reset'));
        this.calculator = this.element.querySelector('form');
        this.copyFields = Array.from(this.element.querySelectorAll('.js-copy-field'));
        this.modalLinks = Array.from(this.element.querySelectorAll('.js-calculator-modal'));
        this.loanTerm = Array.from(this.element.querySelectorAll("input[name=\"loan_terms\"]"));
        this.personToPay = this.element.querySelector("select[name=\"person-to-pay-loan\"]");
        this.applyNowBtn = this.element.querySelector('.js-wpbbsa-calculator-view-quote');
        this.personToPayValue = '';
        dataLayer.pageName = "personal:products and services:borrow for your needs:student loans:calculator";
        TooltipsService.initTooltips();
        this.toggleActionButtons();
    };
    CalculatorsStudentLoans.prototype.bindEvents = function () {
        var _this = this;
        var buttonSteps = Array.from(this.element.querySelectorAll('.accordion span.calculators-student-loans-form__button-step'));
        buttonSteps.forEach(function (element) {
            element.parentElement.removeChild(element);
        });
        this.calculatorSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            // animate back to top
            var btnDoIQualify = Array.from(_this.element.querySelectorAll('.js-calculator-do-i-qualify'));
            if ($(window).width() > 768) {
                $('html,body').animate({
                    scrollTop: $('div.wpbbsa-calculators').offset().top - 10
                }, 'slow');
                btnDoIQualify.forEach(function (element) {
                    element.classList.remove('button--white');
                    element.classList.remove('button--border-blue');
                    element.classList.add('gradient-orange');
                });
            }
            else if ($(window).width() < 768) {
                $('html,body').animate({
                    scrollTop: $('div.wpbbsa-calculator-item__box').offset().top
                }, 'slow');
                setTimeout(function () {
                    btnDoIQualify.forEach(function (element) {
                        element.classList.remove('button--white');
                        element.classList.remove('button--border-blue');
                        element.classList.add('gradient-orange');
                    });
                }, 800);
            }
            var allFields = _this.calculator.querySelectorAll('input');
            if (_this.formValid) {
                var button = event.currentTarget;
                var form = button.closest('form');
                _this.doCalcs(form);
                // Analytics - Trigger form Complete when the user calculates the results
                if (_this.personToPayValue !== '') {
                    _this.analyticsService.dtmFormComplete('complete', '');
                }
                else {
                    _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields| norequest");
                }
            }
        }); });
        this.modifiersRadiosToggle.map(function (item) { return item.addEventListener('click', function (event) {
            var targetField = event.target;
            var visibleGroups = Array.from(_this.element.querySelectorAll('div.' + targetField.getAttribute('data-value')));
            var radioContainers = Array.from(_this.element.querySelectorAll('.js-calculator-radio-group-containers'));
            radioContainers.map(function (item) {
                item.classList.add('calculators-student-loans-form__hidden');
                var inputs = Array.from(item.querySelectorAll('input'));
                inputs.map(function (item) {
                    var getDefaultValue = item.value;
                    if (!getDefaultValue == undefined || getDefaultValue == '') {
                        item.value = '';
                    }
                    else {
                        item.value = getDefaultValue;
                    }
                });
            });
            visibleGroups.map(function (item) {
                item.classList.remove('calculators-student-loans-form__hidden');
            });
        }); });
        this.calculatorReset.map(function (item) { return item.addEventListener('click', function (event) {
            _this.resetInputs(event);
            // animate back to top
            if ($(window).width() > 768) {
                $('html,body').animate({
                    scrollTop: $('div.wpbbsa-calculators').offset().top - 10
                }, 'slow');
            }
        }); });
        this.modifierToggles.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleModifiers(event);
        }); });
        this.addonToggles.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleAddons(event);
        }); });
        this.copyFields.map(function (item) { return item.addEventListener('input', function (event) {
            _this.copyField(event);
        }); });
        this.copyFields.map(function (item) { return item.addEventListener('change', function (event) {
            _this.copyField(event);
        }); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModal(event);
        }); });
        // INPUTS
        this.inputs.map(function (item) { return item.addEventListener('focusin', function (event) {
            _this.onFocusInput(event);
        }); });
        this.inputs.map(function (item) { return item.addEventListener('focusout', function (event) {
            _this.outFocusInput(event);
            _this.validateCalculator(event, _this.calculatorSubmit);
            var _valid = Array.from(_this.element.querySelectorAll('.calculators-student-loans-form__error'));
            if (_valid.length > 0) {
                _this.formValid = false;
                _this.calculatorSubmit.map(function (item) {
                    item.classList.add('button--disabled');
                });
            }
            else {
                _this.formValid = true;
                _this.calculatorSubmit.map(function (item) {
                    item.classList.remove('button--disabled');
                });
            }
        }); });
        this.inputs.map(function (item) { return item.addEventListener('keyup', function (event) {
            _this.keyInput(event);
        }); });
        if (this.personToPay) {
            this.personToPay.addEventListener('change', function (event) {
                _this.personToPayValue = event.currentTarget.value;
                _this.hideDisplayLoanTerm(_this.personToPayValue);
                _this.toggleActionButtons();
            });
        }
        this.applyNowBtn.addEventListener('click', function (event) {
            if (_this.personToPay.value === 'NOONE') {
                _this.personToPay.value = '';
                _this.personToPay.selectedIndex = 0;
            }
        });
    };
    CalculatorsStudentLoans.prototype.hideDisplayLoanTerm = function (personToPay) {
        if (this.loanTerm) {
            if (personToPay === 'STUDENT' || personToPay === "NOONE") {
                [].slice.call(this.loanTerm).forEach(function (div) {
                    div.closest('.form__group').classList.remove('form__group--hidden');
                });
            }
            else if (personToPay === "SURETY") {
                [].slice.call(this.loanTerm).forEach(function (div) {
                    div.closest('.form__group').classList.add('form__group--hidden');
                });
            }
            else {
                [].slice.call(this.loanTerm).forEach(function (div) {
                    div.closest('.form__group').classList.remove('form__group--hidden');
                });
            }
        }
    };
    CalculatorsStudentLoans.prototype.openModal = function (event) {
        var modalId = event.currentTarget.parentNode.getAttribute('data-modal');
        this.event.emit('openModal', {
            id: modalId
        });
    };
    CalculatorsStudentLoans.prototype.copyField = function (event) {
        var fieldParentContainer = this.findFieldCopy(event.currentTarget.parentNode);
        var copyValue = parseFloat(event.currentTarget.value);
        var fieldName = fieldParentContainer.getAttribute('data-target');
        var fields = fieldParentContainer.querySelectorAll(".js-" + fieldName);
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].classList.contains('js-not-zero')) {
                if (copyValue == 0) {
                    copyValue = 1;
                }
            }
            fields[i].value = copyValue;
        }
        // Form form start (if not started yet) when slider is being interacted with
        this.analyticsService.dtmTriggerFormStart(fields[0]);
    };
    CalculatorsStudentLoans.prototype.findFieldCopy = function (parent) {
        while ((parent = parent.parentElement) && !parent.classList.contains('js-copy-fields'))
            ;
        return parent;
    };
    CalculatorsStudentLoans.prototype.toggleActionButtons = function () {
        var applyNowBtn = this.element.querySelector('.js-wpbbsa-calculator-view-quote');
        var formStep = this.element.querySelector('.calculator-form__button-step');
        var selectedPersonToPay = this.personToPay.options[this.personToPay.selectedIndex].value;
        if (selectedPersonToPay === 'NOONE') {
            formStep.innerHTML = 'Step 2: Apply now';
            applyNowBtn['text'] = 'Apply now';
            applyNowBtn['href'] = 'https://www.standardbank.co.za/southafrica/personal/products-and-services/borrow-for-your-needs/student-loans/student-loans/student-loans-without-surety-application';
            applyNowBtn.removeAttribute('data-modal');
            applyNowBtn.setAttribute('data-text', 'student loans calculator | apply now button click');
        }
        else {
            formStep.innerHTML = 'Step 2: Do I Qualify';
            applyNowBtn['text'] = 'Do I qualify?';
            applyNowBtn['href'] = 'javascript:void(0);';
            applyNowBtn.setAttribute('data-modal', 'form-container-student-loans-quote');
            applyNowBtn.setAttribute('data-text', 'student loans calculator | do I qualify button click');
        }
    };
    CalculatorsStudentLoans.prototype.toggleModifiers = function (event) {
        event.preventDefault();
        var targetModifierId = event.currentTarget.parentNode.getAttribute('data-target');
        var targetModifier = this.element.querySelector("#" + targetModifierId);
        if (targetModifier.classList.contains('calculators-student-loans-form__modifiers--open')) {
            targetModifier.classList.remove('calculators-student-loans-form__modifiers--open');
            event.currentTarget.classList.add('calculators-student-loans-form__link--open');
        }
        else {
            targetModifier.classList.add('calculators-student-loans-form__modifiers--open');
            event.currentTarget.classList.remove('calculators-student-loans-form__modifiers--open');
        }
    };
    CalculatorsStudentLoans.prototype.toggleAddons = function (event) {
        event.preventDefault();
        if (event.currentTarget.classList.contains('link--disabled')) {
            return;
        }
        var targetAddonId = event.currentTarget.parentNode.getAttribute('data-target');
        var targetAddon = this.element.querySelector('#' + targetAddonId);
        var targetInput = targetAddon.querySelector('input');
        var _tmpText = event.currentTarget.querySelector('.link__text');
        var _coAppText = this.element.querySelector('.co_app_text');
        if (targetAddon.classList.contains('calculators-student-loans-form__addon--open')) {
            if (targetInput) {
                targetInput.value = '0';
                targetInput.placeholder = '0';
            }
            targetAddon.classList.remove('calculators-student-loans-form__addon--open');
            _tmpText.innerText = '+ Add co-applicant\'s income';
            if (_coAppText) {
                _coAppText.innerText = '';
            }
        }
        else {
            if (targetInput) {
                targetInput.value = '0';
                targetInput.placeholder = '0';
            }
            targetAddon.classList.add('calculators-student-loans-form__addon--open');
            _tmpText.innerText = '- Remove co-applicant\'s income';
            if (_coAppText) {
                _coAppText.innerText = '(including co-applicant)';
            }
        }
    };
    CalculatorsStudentLoans.prototype.resetInputs = function (event) {
        event.preventDefault();
        var errorLabels = Array.from(this.calculator.querySelectorAll('div.form__group'));
        errorLabels.map(function (item) {
            var parent = item;
            $(parent).removeClass('calculators-student-loans-form__error');
            $(parent).find('div.calculators-student-loans-form__error-label').remove();
        });
        this.calculator.reset();
        this.formValid = true;
        this.resetValues(this.calculator);
        this.inputs.map(function (item) {
            if (item.getAttribute('type') != 'radio') {
                item.setAttribute('data-value', 0);
                item.setAttribute('placeholder', 0);
            }
        });
        // Analytics - Trigger form Complete when the user calculates the results
        this.analyticsService.dtmRestartForm();
    };
    CalculatorsStudentLoans.prototype.onFocusInput = function (event) {
        event.preventDefault();
        var field = event.target;
        var _value = parseFloat(field.value);
        var min = parseFloat(field.getAttribute('min'));
        var max = parseFloat(field.getAttribute('max'));
        if (min && max) {
            if ((_value < min) && (_value > max)) {
                field.value = '';
            }
        }
        else {
            if (_value == 0) {
                field.value = '';
            }
        }
    };
    CalculatorsStudentLoans.prototype.outFocusInput = function (event) {
        event.preventDefault();
        var field = event.target;
        if (!field.classList.contains('js-copy-field')) {
            var value = field.getAttribute('data-value');
            // field.value = value;
            if (field.value == '') {
                field.value = value;
            }
        }
        if (field.value == '') {
            field.value = 0;
        }
    };
    CalculatorsStudentLoans.prototype.keyInput = function (event) {
        event.preventDefault();
        this.formValid = true;
        var field = event.target;
        var value = field.value;
        if (!field.classList.contains('js-copy-field')) {
            field.setAttribute('data-value', value);
            field.setAttribute('placeholder', value);
        }
        this.formValid = this.validateCalculator(event, this.calculatorSubmit);
    };
    CalculatorsStudentLoans.prototype.checkBaloonPayments = function (event) {
        var value = event.currentTarget.value;
        var balloonInput = Array.from(this.element.querySelectorAll('.js-balloon'));
        if (balloonInput.length > 0) {
            if (value == '84') {
                balloonInput.forEach(function (element) {
                    element.value = '0';
                    element.placeholder = '0';
                    element.max = '0';
                    element.min = '0';
                    element.setAttribute('data-value', '0');
                });
            }
            else {
                balloonInput.forEach(function (element) {
                    element.value = '1';
                    element.placeholder = '1';
                    element.max = '40';
                    element.min = '1';
                    element.setAttribute('data-value', '1');
                });
            }
        }
    };
    // CALCULATOR SERVICES
    CalculatorsStudentLoans.prototype.doCalcs = function (form) {
        var loanamount = form.querySelector('input[name=loan_amount]');
        var interest = form.querySelector('input[name=loan_interest_rate]');
        var term = form.querySelector('input[name=loan_terms]');
        // const loanRepayment: any = this.element.querySelectorAll('span.js-calculator-student-loan-repayment');
        var monthlyFees = this.element.querySelectorAll('span.js-calculator-monthly-fees-student');
        var monthlyFeesNoOne = this.element.querySelectorAll('span.js-calculator-monthly-fees-noone');
        var monthlyInterest = this.element.querySelectorAll('span.js-calculator-monthly-interest');
        var monthlyFeesSuretyWS = this.element.querySelectorAll('span.js-calculator-monthly-fees-surety-ws');
        var monthlyFeesSuretyAS = this.element.querySelectorAll('span.js-calculator-monthly-fees-surety-as');
        var monthlyFeesDiv = this.element.querySelectorAll('div.js-calculator-monthly-fees-student--div');
        var monthlyFeesNoOneDiv = this.element.querySelectorAll('div.js-calculator-monthly-fees-noone--div');
        var monthlyInterestDiv = this.element.querySelectorAll('div.js-calculator-monthly-interest--div');
        var monthlyFeesSuretyWSDiv = this.element.querySelectorAll('div.js-calculator-monthly-fees-surety-ws--div');
        var monthlyFeesSuretyASDiv = this.element.querySelectorAll('div.js-calculator-monthly-fees-surety-as--div');
        var answer;
        if (this.personToPayValue === "STUDENT" || this.personToPayValue === "NOONE") {
            answer = this.doStudentCalc(loanamount.value, interest.value, term.value);
        }
        else if (this.personToPayValue === "SURETY") {
            answer = this.doSuretyCalc(loanamount.value, interest.value);
        }
        else {
            answer = { monthlyFees: '0', monthlyInterest: '0', monthlyFeesWS: '0', monthlyFeesAS: '0' };
        }
        if (this.personToPayValue === "NOONE") {
            // -- Display / Hide Divs -- //
            [].slice.call(monthlyFeesNoOneDiv).forEach(function (div) {
                div.classList.remove('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyInterestDiv).forEach(function (div) {
                div.classList.remove('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesSuretyWSDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesSuretyASDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesNoOne).forEach(function (div) {
                div.innerHTML = answer.monthlyFees.toLocaleString('en-ZA', {
                    style: 'currency',
                    currency: 'ZAR',
                    minimumFractionDigits: 2
                });
            });
            [].slice.call(monthlyInterest).forEach(function (div) {
                div.innerHTML = answer.monthlyInterest.toLocaleString('en-ZA', {
                    style: 'currency',
                    currency: 'ZAR',
                    minimumFractionDigits: 2
                });
            });
            [].slice.call(monthlyFees).forEach(function (div) {
                div.innerHTML = answer.monthlyFees;
            });
            [].slice.call(monthlyFeesSuretyWS).forEach(function (div) {
                div.innerHTML = answer.monthlyFeesWS;
            });
            [].slice.call(monthlyFeesSuretyAS).forEach(function (div) {
                div.innerHTML = answer.monthlyFeesAS;
            });
        }
        else if (this.personToPayValue === 'STUDENT') {
            // -- Display / Hide Divs -- //
            [].slice.call(monthlyFeesDiv).forEach(function (div) {
                div.classList.remove('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyInterestDiv).forEach(function (div) {
                div.classList.remove('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesNoOneDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesSuretyWSDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesSuretyASDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFees).forEach(function (div) {
                div.innerHTML = answer.monthlyFees.toLocaleString('en-ZA', {
                    style: 'currency',
                    currency: 'ZAR',
                    minimumFractionDigits: 2
                });
            });
            [].slice.call(monthlyInterest).forEach(function (div) {
                div.innerHTML = answer.monthlyInterest.toLocaleString('en-ZA', {
                    style: 'currency',
                    currency: 'ZAR',
                    minimumFractionDigits: 2
                });
            });
            [].slice.call(monthlyFeesNoOne).forEach(function (div) {
                div.innerHTML = answer.monthlyFees;
            });
            [].slice.call(monthlyFeesSuretyWS).forEach(function (div) {
                div.innerHTML = answer.monthlyFeesWS;
            });
            [].slice.call(monthlyFeesSuretyAS).forEach(function (div) {
                div.innerHTML = answer.monthlyFeesAS;
            });
        }
        else if (this.personToPayValue === "SURETY") {
            // -- Display / Hide Divs -- //
            [].slice.call(monthlyFeesDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesNoOneDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyInterestDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesSuretyWSDiv).forEach(function (div) {
                div.classList.remove('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesSuretyASDiv).forEach(function (div) {
                div.classList.remove('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyInterest).forEach(function (div) {
                div.innerHTML = answer.monthlyInterest.toLocaleString('en-ZA', {
                    style: 'currency',
                    currency: 'ZAR',
                    minimumFractionDigits: 2
                });
            });
            [].slice.call(monthlyFees).forEach(function (div) {
                div.innerHTML = answer.monthlyFees;
            });
            [].slice.call(monthlyFeesNoOne).forEach(function (div) {
                div.innerHTML = answer.monthlyFees;
            });
            [].slice.call(monthlyFeesSuretyWS).forEach(function (div) {
                div.innerHTML = answer.monthlyFeesWS.toLocaleString('en-ZA', {
                    style: 'currency',
                    currency: 'ZAR',
                    minimumFractionDigits: 2
                });
            });
            [].slice.call(monthlyFeesSuretyAS).forEach(function (div) {
                div.innerHTML = answer.monthlyFeesAS.toLocaleString('en-ZA', {
                    style: 'currency',
                    currency: 'ZAR',
                    minimumFractionDigits: 2
                });
            });
        }
        else {
            // -- Display / Hide Divs -- //
            [].slice.call(monthlyFeesDiv).forEach(function (div) {
                div.classList.remove('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyInterestDiv).forEach(function (div) {
                div.classList.remove('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesNoOneDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesSuretyWSDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            [].slice.call(monthlyFeesSuretyASDiv).forEach(function (div) {
                div.classList.add('wpbbsa-calculator-form__hidden');
            });
            // Display Results
            // [].slice.call(loanRepayment).forEach(function (div) {
            // 	div.innerHTML = answer.totalRepayment;
            // });
            [].slice.call(monthlyFees).forEach(function (div) {
                div.innerHTML = answer.monthlyFees;
            });
            [].slice.call(monthlyFeesNoOne).forEach(function (div) {
                div.innerHTML = answer.monthlyFees;
            });
            [].slice.call(monthlyInterest).forEach(function (div) {
                div.innerHTML = answer.monthlyInterest;
            });
            [].slice.call(monthlyFeesSuretyWS).forEach(function (div) {
                div.innerHTML = answer.monthlyFeesWS;
            });
            [].slice.call(monthlyFeesSuretyAS).forEach(function (div) {
                div.innerHTML = answer.monthlyFeesAS;
            });
        }
    };
    CalculatorsStudentLoans.prototype.doStudentCalc = function (loanAmount, totIntRateCharged, loanTerm) {
        var monthlyServiceFee = 69; // Constant
        var totIntRateChargedPercntg = Number(totIntRateCharged) / 100;
        var paymentsPerYear = 12; // Constant
        var initiationFee = 74.75 + (0.115 * Number(loanAmount));
        if (initiationFee > 1207.5) {
            initiationFee = 1207.5;
        }
        var principleDebt = initiationFee + Number(loanAmount);
        var pmt = principleDebt * ((totIntRateChargedPercntg / paymentsPerYear) / (1 - (Math.pow(1 + (totIntRateChargedPercntg / paymentsPerYear), ((-1) * Number(loanTerm))))));
        var totalRepayment = (pmt * Number(loanTerm)) + (monthlyServiceFee * Number(loanTerm));
        var monthlyFees = totalRepayment / Number(loanTerm);
        var monthlyInterest = (totalRepayment - Number(loanAmount)) / Number(loanTerm);
        var monthlyFeesWS = 0;
        var monthlyFeesAS = 0;
        return { monthlyFees: monthlyFees, monthlyInterest: monthlyInterest, monthlyFeesWS: monthlyFeesWS, monthlyFeesAS: monthlyFeesAS };
    };
    CalculatorsStudentLoans.prototype.doSuretyCalc = function (loanAmount, totIntRateCharged) {
        var monthlyServiceFee = 69; // Constant
        var loanTermFTWS = 12; // Constant
        var loanTermFTAS = 60; // Constant
        var totIntRateChargedPercntg = Number(totIntRateCharged) / 100;
        var paymentsPerYear = 12; // Constant
        var initiationFee = 74.75 + (0.115 * Number(loanAmount));
        if (initiationFee > 1207.5) {
            initiationFee = 1207.5;
        }
        // Full Time While Studying
        var principleDebtFTWS = initiationFee + Number(loanAmount);
        var monthlyFeesWS = ((principleDebtFTWS * totIntRateChargedPercntg) / loanTermFTWS) + monthlyServiceFee + 50;
        var totalFeesWS = monthlyFeesWS * loanTermFTWS;
        // Full Time After Studying
        var pmt = principleDebtFTWS * ((totIntRateChargedPercntg / paymentsPerYear) / (1 - (Math.pow(1 + (totIntRateChargedPercntg / paymentsPerYear), ((-1) * loanTermFTAS)))));
        var totalFeesAS = (pmt * loanTermFTAS) + (monthlyServiceFee * loanTermFTAS);
        var monthlyFeesAS = totalFeesAS / loanTermFTAS;
        var monthlyFees = 0;
        var monthlyInterest = 0;
        return { monthlyFees: monthlyFees, monthlyInterest: monthlyInterest, monthlyFeesWS: monthlyFeesWS, monthlyFeesAS: monthlyFeesAS };
    };
    // RESET VALUES	- OUTPUTS
    CalculatorsStudentLoans.prototype.resetValues = function (form) {
        switch (form.id) {
            case 'calculator student loans how much do i qualify for':
                this.personToPayValue = '';
                var loanamount = form.querySelector('input[name=loan_amount]');
                // const loanRepayment: any = this.element.querySelectorAll('span.js-calculator-student-loan-repayment');
                var monthlyFees = this.element.querySelectorAll('span.js-calculator-monthly-fees-student');
                var monthlyFeesNoOne = this.element.querySelectorAll('span.js-calculator-monthly-fees-noone');
                var monthlyInterest = this.element.querySelectorAll('span.js-calculator-monthly-interest');
                var monthlyFeesSuretyWS = this.element.querySelectorAll('span.js-calculator-monthly-fees-surety-ws');
                var monthlyFeesSuretyAS = this.element.querySelectorAll('span.js-calculator-monthly-fees-surety-as');
                var monthlyFeesDiv = this.element.querySelectorAll('div.js-calculator-monthly-fees-student--div');
                var monthlyFeesNoOneDiv = this.element.querySelectorAll('div.js-calculator-monthly-fees-noone--div');
                var monthlyInterestDiv = this.element.querySelectorAll('div.js-calculator-monthly-interest--div');
                var monthlyFeesSuretyWSDiv = this.element.querySelectorAll('div.js-calculator-monthly-fees-surety-ws--div');
                var monthlyFeesSuretyASDiv = this.element.querySelectorAll('div.js-calculator-monthly-fees-surety-as--div');
                this.toggleActionButtons();
                // -- Display / Hide Divs -- //
                if (this.loanTerm.length > 0) {
                    [].slice.call(this.loanTerm).forEach(function (div) {
                        div.closest('.form__group').classList.remove('form__group--hidden');
                    });
                }
                [].slice.call(monthlyFeesDiv).forEach(function (div) {
                    div.classList.remove('wpbbsa-calculator-form__hidden');
                });
                [].slice.call(monthlyInterestDiv).forEach(function (div) {
                    div.classList.remove('wpbbsa-calculator-form__hidden');
                });
                [].slice.call(monthlyFeesNoOneDiv).forEach(function (div) {
                    div.classList.add('wpbbsa-calculator-form__hidden');
                });
                [].slice.call(monthlyFeesSuretyWSDiv).forEach(function (div) {
                    div.classList.add('wpbbsa-calculator-form__hidden');
                });
                [].slice.call(monthlyFeesSuretyASDiv).forEach(function (div) {
                    div.classList.add('wpbbsa-calculator-form__hidden');
                });
                // Display Results
                [].slice.call(loanamount).forEach(function (div) {
                    div.innerHTML = '80000';
                });
                // [].slice.call(loanRepayment).forEach(function (div) {
                // 	div.innerHTML = '0';
                // });
                [].slice.call(monthlyFees).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(monthlyFeesNoOne).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(monthlyInterest).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(monthlyFeesSuretyWS).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(monthlyFeesSuretyAS).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            default:
                break;
        }
    };
    //
    //
    // STUDENT LOANS CUSTOM CALCULATOR VALIDATIONS
    //
    //
    CalculatorsStudentLoans.prototype.validateCalculator = function (event, button) {
        // varaibles
        event.preventDefault();
        var field = event.target;
        var formValid = true;
        var fieldValue = field.value;
        var fieldAddon = field;
        var required = field.getAttribute('data-validation-required');
        var title = field.getAttribute('data-validation-title');
        var minimum = parseFloat(field.getAttribute('min'));
        var maximum = parseFloat(field.getAttribute('max'));
        var greaterThan = field.getAttribute('data-validation-greater-than');
        var lessThan = field.getAttribute('data-validation-less-than');
        // removeErrors
        $(field).closest('.calculators-student-loans-form__group').removeClass('calculators-student-loans-form__error');
        $(field).closest('.calculators-student-loans-form__group').find('div.calculators-student-loans-form__error-label').remove();
        // required
        if (required == 'true') {
            if (fieldValue.length == 0) {
                formValid = false;
                if (minimum) {
                    if (maximum) {
                        if (title) {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                        }
                        else {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                        }
                    }
                    else {
                        this.validateCalculatorError(event, 'Enter an amount');
                    }
                }
                else {
                    this.validateCalculatorError(event, 'Enter an amount');
                }
            }
        }
        // min
        if (minimum > parseFloat(fieldValue)) {
            formValid = false;
            if (title && maximum) {
                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
            }
            else if (!title && maximum) {
                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
            }
            else if (!title && !maximum) {
                this.validateCalculatorError(event, 'Enter an amount');
            }
        }
        // max
        if (maximum > 0) {
            if (maximum < parseFloat(fieldValue)) {
                formValid = false;
                if (title) {
                    this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                }
                else {
                    this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                }
            }
        }
        else {
            if (maximum < parseFloat(fieldValue)) {
                formValid = false;
                if (title) {
                    this.validateCalculatorError(event, 'The maximum you can insert is 0 ' + title);
                }
                else {
                    this.validateCalculatorError(event, 'The maximum you can insert is 0');
                }
            }
        }
        // greater than
        if (greaterThan) {
            var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
            if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                formValid = false;
                this.validateCalculatorError(event, 'Enter an amount greater than the expenses field');
            }
        }
        // less than
        if (lessThan) {
            var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
            if (fieldsLessThan.length > 1) {
                var amount_1 = 0;
                $(fieldsLessThan).each(function (index) {
                    var valueElement = $(this).val();
                    if (!valueElement) {
                        amount_1 = amount_1 + 0;
                    }
                    else {
                        amount_1 = amount_1 + parseFloat(valueElement);
                    }
                });
                if (parseFloat(fieldValue) >= amount_1) {
                    formValid = false;
                    this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                }
            }
            else {
                if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                    formValid = false;
                    this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                }
            }
        }
        return formValid;
    };
    CalculatorsStudentLoans.prototype.validateCalculatorError = function (event, message) {
        if (message === void 0) { message = ''; }
        event.preventDefault();
        var field = event.target;
        var closestGroup = field.closest('.calculators-student-loans-form__group');
        $(closestGroup).addClass('calculators-student-loans-form__error').append('<div class="calculators-student-loans-form__error-label">' + message + '</div>');
    };
    CalculatorsStudentLoans.prototype.formatNumbers = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ' ' + '$2');
        }
        return x1 + x2;
    };
    return CalculatorsStudentLoans;
}(Base));
export { CalculatorsStudentLoans };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculators-student-loans/calculators-student-loans.component.ts
// module id = 813
// module chunks = 0